export const assessmentFormRoutes = [
    {
        path: '',
        name: 'BeginAssessment',
        component: () => import('../views/BeginAssessment.vue'),
        meta: {
            breadcrumb: [{ parent: 'ASSESSMENTS FORM' }],
            requiresAuth: true,
        },
    },
    {
        path: ':assessmentCode/:userId',
        name: 'AnswerAssessment',
        props: true,
        component: () => import('../views/AssessmentFormSubmission.vue'),
        meta: {
            breadcrumb: [{ parent: 'ASSESSMENTS FORM', label: 'ANSWER ASSESSMENT' }],
            requiresAuth: true,
        },
    },
];
